import { UserApiClient } from "@bloomberg/intercom";

const userApiClient = UserApiClient.init({
    host: `${process.env.NEXT_PUBLIC_REGISTRATION_URL}/user-api`,
});

export { userApiClient };
